import { render, staticRenderFns } from "./FacebookLocationsApp.vue?vue&type=template&id=12fbb3a4&lang=pug"
import script from "./FacebookLocationsApp.vue?vue&type=script&lang=js"
export * from "./FacebookLocationsApp.vue?vue&type=script&lang=js"
import style0 from "./FacebookLocationsApp.vue?vue&type=style&index=0&id=12fbb3a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports